import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";

interface Props {
  open: boolean;
}

export default function GlobalPageLoader({ open }: Props) {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2000,
        backdropFilter: "blur(3px)",
        backgroundColor: "rgba(255, 255, 255, 0.35)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          px: 2,
          py: 1.5,
          borderRadius: "12px",
          backgroundColor: "rgba(255, 255, 255, 0.72)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}
      >
        {[0, 1, 2].map((dot) => (
          <Box
            key={dot}
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#20b24b",
              animation: "waaDotPulse 0.9s ease-in-out infinite",
              animationDelay: `${dot * 0.12}s`,
              "@keyframes waaDotPulse": {
                "0%, 80%, 100%": {
                  opacity: 0.25,
                  transform: "translateY(0)",
                },
                "40%": {
                  opacity: 1,
                  transform: "translateY(-4px)",
                },
              },
            }}
          />
        ))}
      </Box>
    </Backdrop>
  );
}
